import { CopyToClipboard } from '@/components/common/copy-to-clipboard';

import styles from './cells.module.scss';
import { textCell } from './text-cell';

// The value truncates inside a bounded (ADR-0032) column with the copy control kept visible, and
// `textCell`'s tooltip keeps the full id one hover away (ADO 120966). Unbounded columns never truncate.
export function idCell(value: string) {
  return (
    <span className={styles.id}>
      {textCell(value)}
      <CopyToClipboard value={value} className={styles.idCopy} />
    </span>
  );
}
